import { Component, OnInit, Input } from '@angular/core';
import { TrainingService } from 'src/app/training/src/training.service';

@Component({
	selector: 'exercice-list',
	templateUrl: './exercice-list.html',
	styleUrls: ['./exercice-list.scss']
})
export class ExerciceList {
	@Input('user') user;

	constructor(private trainingService: TrainingService) { }

	ngOnChanges() {

		console.log(this.user)
	}

}
